// en  zh-cn  ru
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementRuLocale from 'element-ui/lib/locale/lang/ru-RU' // element-ui lang
import enLocale from './en/index'
import zhLocale from './zh/index'
import ruLocale from './ru/index'

Vue.use(VueI18n)

const messages = {
    'en_US': {
        ...enLocale,
        ...elementEnLocale
    },
    'zh_CN': {
        ...zhLocale,
        ...elementZhLocale
    },
    'ru_RU': {
        ...ruLocale,
        ...elementRuLocale
    },
}

// 获取当前语言
export function getLanguage() {
    const chooseLanguage = Cookies.get('language')
    if (chooseLanguage) return chooseLanguage

    // 如果没有选择语言
    const language = (navigator.language || navigator.browserLanguage).toLowerCase()
    if (language === 'en') {
        return 'en_US'
    } else if (language === 'zh-cn') {
        return 'zh_CN'
    } else if (language === 'ru') {
        return 'ru_RU'
    }
    return 'zh_CN'
}

const i18n = new VueI18n({
    locale: getLanguage(),
    fallbackLocale: 'zh_CN',
    messages
})

export default i18n
